function e(e,n){return n?e*(1e3/n):0}export{e as velocityPerSecond};
